import { j as I } from "./atoms-v218.js";
import r, { forwardRef as g, useMemo as j, useState as x } from "react";
import { AccordionItem as a } from "./atoms-v21041.js";
import { Accordion as C } from "./atoms-v21229.js";
const p = g(
  ({ ariaHidden: i = !1, ariaLabel: m, children: n, className: d, id: l }, c) => {
    const u = j(() => {
      var s;
      const o = r.Children.toArray(n).find(
        (t) => r.isValidElement(t) && t.type === a && !!t.props.defaultOpen
      );
      return ((s = o == null ? void 0 : o.props) == null ? void 0 : s.id) ?? null;
    }, [n]), [f, A] = x(u), y = (e) => {
      A((o) => o === e ? null : e);
    };
    return /* @__PURE__ */ I.jsx(
      C,
      {
        "aria-hidden": i,
        "aria-label": m,
        className: d,
        id: l,
        ref: c,
        children: r.Children.map(n, (e) => r.isValidElement(e) && e.type === a ? r.cloneElement(e, {
          isOpen: f === e.props.id,
          onToggle: y
        }) : e)
      }
    );
  }
);
p.displayName = "Components.Accordion";
const T = Object.assign(p, { AccordionItem: a });
export {
  T as Accordion
};
